import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Button from "../Button";

interface TimeButtonProps {
  time?: number;
  handleClick: () => void;
  btnText: string;
  text: string;
}

const TimeButton: React.FC<TimeButtonProps> = ({ time = 5, handleClick, text, btnText }) => {
  const [secondsLeft, setSecondsLeft] = useState<number>(time);

  useEffect(() => {
    if (secondsLeft > 0) {
      const timer = setTimeout(() => setSecondsLeft(secondsLeft - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      handleClick();
    }
  }, [secondsLeft, handleClick]);

  return (
    <div className=" flex justify-center flex-col">
      <motion.p initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="text-sm px-8 text-center text-gray-500 mt-2">
        {text} in
        <span className=" text-primary"> {secondsLeft} sec</span>
      </motion.p>

      <Button variant="primary" size="small" className=" my-5" isFullWidth onClick={handleClick}>
        {btnText}
      </Button>
    </div>
  );
};

export default TimeButton;
